module.exports = __webpack_public_path__ + "media/95.3681c00e.mp3";